import { enCA, enGB, enUS, es, fr, pt, ptBR } from "date-fns/locale";
const locales = {
    'en-US': enUS,
    'en-GB': enGB,
    'en-CA': enCA,
    'pt-BR': ptBR,
    pt: pt,
    es: es,
    fr: fr
};
function supportedLocale(locale) {
    if (locales[locale]) return locale;
    if (locales[locale.substring(0, 2)]) return locale.substring(0, 2);
    return 'en-US';
}
function validateLocale(aliasLocale) {
    if (!aliasLocale) return 'en-US';
    if ('en' === aliasLocale) return 'en-US';
    const matchedLocale = aliasLocale.match(/([a-z]{2})(?:-?([a-zA-Z]{2})?)/);
    if (!matchedLocale) return 'en-US';
    if (matchedLocale.length && void 0 === matchedLocale[2]) return supportedLocale(matchedLocale[1]);
    return supportedLocale(matchedLocale[1].concat('-', matchedLocale[2].toUpperCase()));
}
function capitalizeLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const NOON = 24;
const HOURS = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];
function parseStandardTime(time) {
    const [hours, minutes] = time.split(':');
    const numericHours = Number(hours);
    let standardHours = numericHours;
    if (0 === numericHours) standardHours = 12;
    else if (numericHours > 12) standardHours = numericHours - 12;
    return `${standardHours}:${minutes}`;
}
function normalizeConfig(config) {
    if ('string' == typeof config) return {
        locale: config,
        meridiemCase: 'locale'
    };
    return {
        locale: config?.locale ?? 'en-US',
        meridiemCase: config?.meridiemCase ?? 'locale'
    };
}
function normalizeMeridiem(value, meridiemCase) {
    if ('lower' === meridiemCase) return value?.toLowerCase();
    return value;
}
function generateTimeSelectOptions(config) {
    const { locale, meridiemCase } = normalizeConfig(config);
    const dateFnsLocale = locales[validateLocale(locale)];
    const am = normalizeMeridiem(dateFnsLocale.localize?.dayPeriod('am', {
        width: 'abbreviated'
    }), meridiemCase);
    const pm = normalizeMeridiem(dateFnsLocale.localize?.dayPeriod('pm', {
        width: 'abbreviated'
    }), meridiemCase);
    const noon = dateFnsLocale.localize?.dayPeriod('noon', {
        width: 'abbreviated'
    });
    const midnight = dateFnsLocale.localize?.dayPeriod('midnight', {
        width: 'abbreviated'
    });
    const timeFormat = dateFnsLocale.formatLong?.time({
        width: 'short'
    });
    return HOURS.map((time, index)=>{
        const isBeforeNoon = index < NOON;
        const meridiem = isBeforeNoon ? am : pm;
        let label = 'HH:mm' === timeFormat ? time : `${parseStandardTime(time)} ${meridiem}`;
        if ('00:00' === time) label = capitalizeLetter(midnight);
        if ('00:30 AM' === label) label = '12:30 AM';
        if ('12:00' === time) label = capitalizeLetter(noon);
        return {
            label,
            value: time
        };
    });
}
export { generateTimeSelectOptions };
